import HttpService from '../baseHttp'


//亚马逊模板
export const HttpTemplateList = (data = {}, config) => HttpService.get('/api/v2/AmazonTemplate/findByPage', { params: data })
export const HttpUpdateTemplate = (data = {}, config) => HttpService.post('/api/v2/AmazonTemplate/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpTemplate = (data = {}, config) => HttpService.get('/api/v2/AmazonTemplate/getById', { params: data })

//虚拟库存分组
export const HttpVsList = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroup/findByPage', { params: data })
export const HttpVsDetail = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroup/getById', { params: data })
export const HttpSaveVs = (data = {}, config) => HttpService.post('/api/v2/StockVirtualGroup/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpCancelVs = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroup/cancel', { params: data })
export const HttpActiveVs = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroup/active', { params: data })
export const HttpCopyVs = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroup/copy2sku', { params: data })
export const HttpInitVs = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroup/initGroup', { params: data })
export const HttpInitVsSku = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroup/initErpSku', { params: data })
export const HttpGroupRuleItem = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroupRule/item/findByPage', { params: data })
export const HttpGroupRuleAlert = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroupRule/item/findByTransfer', { params: data })
export const HttpBatchDeleteWarehouse = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroup/del/warehouse', { params: data });
// 编辑 渠道、仓库、比例、阶梯
export const HttpEditorChannel = (data = {}, config) => HttpService.post('/api/v2/StockVirtualGroup/account', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpEditorWarehouse = (data = {}, config) => HttpService.post('/api/v2/StockVirtualGroup/warehouse', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpEditorAllot = (data = {}, config) => HttpService.post('/api/v2/StockVirtualGroup/scale', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpEditorLadder = (data = {}, config) => HttpService.post('/api/v2/StockVirtualGroup/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 请求模板列表
export const HttpGetTemplate = (data = {}, config) => HttpService.get('/api/v2/StockTemplate/findByRule', { params: data })



// 虚拟库存明细
export const HttpVsStockList = (data = {}, config) => HttpService.get('/api/v2/StockGroupInventory/findByPage', { params: data })
export const HttpVsStock = (data = {}, config) => HttpService.get('/api/v2/StockGroupInventory/detail/findByPage', { params: data })

//虚拟调拨
export const HttpVsAllotList = (data = {}, config) => HttpService.get('/api/v2/StockTransfer/findByPage', { params: data })
export const HttpVsAllot = (data = {}, config) => HttpService.get('/api/v2/StockTransfer/getById', { params: data })
export const HttpActiveVsAllot = (data = {}, config) => HttpService.get('/api/v2/StockTransfer/batch/active', { params: data })
export const HttpDelVsAllot = (data = {}, config) => HttpService.get('/api/v2/StockTransfer/batch/cancel', { params: data })
export const HttpUpdateVsAllot = (data = {}, config) => HttpService.post('/api/v2/StockTransfer/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpVsAllotNo = (data = {}, config) => HttpService.get('/api/v2/StockTransfer/getTransferNo', { params: data })
export const HttpVsQuantity = (data = {}, config) => HttpService.get('/api/v2/StockTransfer/getInventory', { params: data })
export const HttpProductByLineId = (data = {}, config) => HttpService.get('/api/v1/Product/findByLineId', { params: data })
// 单sku
export const HttpVsSkuList = (data = {}, config) => HttpService.get('/api/v1/Product/findByPage', { params: data })
// 单仓sku
export const HttpWareSkuList = (data = {}, config) => HttpService.get('api/v2/inventory/findByPage', { params: data })
export const HttpInitWareSku = (data = {}, config) => HttpService.post('/api/v2/StockGroupInventory/save/initSku', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 库存分配Sa=stock allot
export const HttpSaTemplateList = (data = {}, config) => HttpService.get('/api/v2/StockTemplate/findByPage', { params: data })
export const HttpDelSaTemplate = (data = {}, config) => HttpService.get('/api/v2/StockTemplate/cancel', { params: data })
export const HttpUpdateSaTemplate = (data = {}, config) => HttpService.post('/api/v2/StockTemplate/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpSaTemplate = (data = {}, config) => HttpService.get('/api/v2/StockTemplate/getById', { params: data })
// 复制sku
export const HttpSaTemplateSku = (data = {}, config) => HttpService.get('/api/v2/StockTemplate/sku/save', { params: data })

// 获取操作历史
export const HttpSysOpLog = (data = {}, config) => HttpService.get('/api/v1/SysOpLog/findByPage', { params: data })
export const HttpSysOpLogNew = (data = {}, config) => HttpService.get('/api/v2/StockOpLog/findByPage', { params: data })


// 分配结果
export const HttpAmazonAccountList = (data = {}, config) => HttpService.get('/api/v2/StockAccountAssign/amazon', { params: data })
export const HttpSaAccountList = (data = {}, config) => HttpService.get('/api/v2/StockAccountAssign/warehouse', { params: data })
export const HttpSummaryAccountList = (data = {}, config) => HttpService.get('/api/v2/StockAccountAssign/collect', { params: data })

//库存锁定
export const HttpSaLockList = (data = {}, config) => HttpService.get('/api/v2/StockLock/findByPage', { params: data })
export const HttpSaLock = (data = {}, config) => HttpService.get('/api/v2/StockLock/getById', { params: data })
export const HttpDelSaLock = (data = {}, config) => HttpService.get('/api/v2/StockLock/batch/cancel', { params: data })
export const HttpUpdateSaLock = (data = {}, config) => HttpService.post('/api/v2/StockLock/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpUpdateSaLockOperate = (data = {}, config) => HttpService.get('/api/v2/StockLock/batch/dealActive', { params: data })
export const HttpActiveSaLock = (data = {}, config) => HttpService.get('/api/v2/StockLock/batch/active', { params: data })
export const HttpDealSaLock = (data = {}, config) => HttpService.get('/api/v2/StockLock/batch/dealActive', { params: data })

export const HttpSellerSku = (data = {}, config) => HttpService.get('/api/v1/ProductChannel/findByPage', { params: data })




// 渠道仓库 wh=warehouse
export const HttpWhAccountList = (data = {}, config) => HttpService.get('/api/v2/StockAccountAddress/findByPage', { params: data })
export const HttpWhAccount = (data = {}, config) => HttpService.get('/api/v2/StockAccountAddress/getByAccountId', { params: data })
export const HttpCancelWhAccount = (data = {}, config) => HttpService.get('/api/v2/StockAccountAddress/cancel', { params: data })
export const HttpUpdateWhAccount = (data = {}, config) => HttpService.post('/api/v2/StockAccountAddress/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

export const HttpAccountType = (data = {}, config) => HttpService.get('/api/v1/ChannelCategory/findAll', { params: data })
export const HttpWhAccountLog = (data = {}, config) => HttpService.get('/api/v1/SysOpLog/findByPage', { params: data })


//渠道商品序列号
export const HttpSerialNoList = (data = {}, config) => HttpService.get('/api/v2/ChannelProductSerialNos/findByPage', { params: data })
export const HttpSerialNo = (data = {}, config) => HttpService.get('/api/v2/ChannelProductSerialNos/getById', { params: data })
export const HttpSerialNoCannel = (data = {}, config) => HttpService.get('/api/v2/ChannelProductSerialNos/batch/cancel', { params: data })
export const HttpSerialNoEdit = (data = {}, config) => HttpService.post('/api/v2/ChannelProductSerialNos/save', data, { params: { contextId: global.SYSID } })


//任务中心
export const HttpTaskCenterList = (data = {}, config) => HttpService.get('/api/v1/TaskCenter/findByPage', { params: data })
export const HttpTaskCenter = (data = {}, config) => HttpService.get('/api/v1/TaskCenter/findById', { params: data })
export const HttpTaskCenterCancel = (data = {}, config) => HttpService.get('/api/v1/TaskCenter/cancel', { params: data })
export const HttpTaskCenterAgain = (data = {}, config) => HttpService.get('/api/v1/TaskCenter/again', { params: data })


// 亚马逊模板生产小程序
export const HttpSaveProgram = (data = {}, config) => HttpService.get('/api/v2/AmazonTemplate/group/warehouse', { params: data })
// export const HttpSaveProgram = (data = {}, config) => HttpService.post('/api/v2/AmazonTemplate/group/warehouse', data, { params: { contextId: global.SYSID } })









